import { inject, Injectable } from "@angular/core";
import { firstValueFrom, map } from "rxjs";
import { SeFeApiService } from "se-fe-api";
import { Organization } from "../models/organization";
import { Tenant } from "../models/tenant";
import { TENANT_KEY } from "./tenant-key.provider";

@Injectable({
  providedIn: 'root',
})
export class OrganizationService {
  private tenantKey = inject(TENANT_KEY) as string;
  private readonly tenant: Tenant = new Tenant(this.tenantKey);
  private api = inject(SeFeApiService);
  private promise?: Promise<Organization>;

  getOrganization() {
    if (!this.promise) {
      this.promise = firstValueFrom(
        this.api.get<Organization>(`organizations/${this.tenant.id}`)
          .pipe(
            map(result => {
              return result.result;
            })
          )
      );
    }
    return this.promise;
  }
}
